import { AwardRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createAward: (
  fetchContext: FetchContext,
  award: AwardRequest,
  accessToken?: string,
) => Promise<number> = async (fetchContext, award, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/awards`,
  {
    method: 'POST',
    body: JSON.stringify(award),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'create award'));
